import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects'

import {
  SEARCH_COLLECTORS,
  AUTOCOMPLETE_COLLECTORS,
  GET_COLLECTOR,
  GET_COLLECTOR_CLIENTS,
  ADD_CLIENT_TO_COLLECTOR,
  REMOVE_CLIENT_FROM_COLLECTOR,
  UPDATE_COLLECTOR_RECIPIENTS,
} from '../constants/ActionsTypes'

import {
  searchCollectors as searchCollectorsApi,
  getCollector as getCollectorApi,
  getCollectorClients as getCollectorClientsApi,
  addClientToCollector as addClientToCollectorApi,
  removeClientFromCollector as removeClientFromCollectorApi,
  updateCollectorRecipients as updateCollectorRecipientsApi,
} from '../api/Collectors'

import {
  searchCollectorsSuccess,
  autocompleteCollectorsSuccess,
  getCollectorSuccess,
  getCollectorError,
  getCollectorClientsSuccess,
  addClientToCollectorSuccess,
  removeClientFromCollectorSuccess,
  getCollectorClients,
  updateCollectorRecipientsSuccess,
  updateCollectorRecipientsError,
} from '../actions/Collectors'

import { showMessages } from '../actions/Notifications'

export const getCommonState = (state) => state.common

function* searchCollectorsRequest({ payload }) {
  const params = yield select(getCommonState)
  const { AdminActionBar } = params

  if (AdminActionBar.showRemove) {
    payload.borrado = AdminActionBar.showRemove
  }

  try {
    const { response } = yield call(searchCollectorsApi, payload)
    yield put(searchCollectorsSuccess(response))
  } catch (error) {}
}

function* autocompleteCollectorsRequest({ payload }) {
  const params = yield select(getCommonState)
  const { AdminActionBar } = params

  const query = {
    filtro: payload,
    page: 1,
    pageSize: 10,
  }

  if (AdminActionBar.showRemove) {
    query.borrado = AdminActionBar.showRemove
  }

  try {
    const collectors = yield call(searchCollectorsApi, query)
    yield put(autocompleteCollectorsSuccess(collectors))
  } catch (error) {}
}

function* getCollectorRequest({ payload }) {
  try {
    const { response } = yield call(getCollectorApi, payload)
    yield put(getCollectorSuccess(response))
  } catch (error) {
    yield put(getCollectorError(error))
  }
}

function* getCollectorClientsRequest({ payload }) {
  try {
    const { collectorId, params } = payload
    const { response } = yield call(getCollectorClientsApi, collectorId, params)
    yield put(getCollectorClientsSuccess(response))
  } catch (error) {}
}

function* addClientToCollectorRequest({ payload }) {
  try {
    const { collectorId, clientId } = payload
    const result = yield call(addClientToCollectorApi, collectorId, clientId)
    yield put(addClientToCollectorSuccess(result))
    // Refresh the clients list
    yield put(getCollectorClients(collectorId, { filtro: '', page: 1, pageSize: 10 }))
    // Show success message
    yield put(
      showMessages({
        summary: 'Client added successfully',
        type: 'success',
      }),
    )
  } catch (error) {}
}

function* removeClientFromCollectorRequest({ payload }) {
  try {
    const { collectorId, clientId } = payload
    const result = yield call(removeClientFromCollectorApi, collectorId, clientId)
    yield put(removeClientFromCollectorSuccess(result))
    // Refresh the clients list
    yield put(getCollectorClients(collectorId, { filtro: '', page: 1, pageSize: 10 }))
    // Show success message
    yield put(
      showMessages({
        summary: 'Client removed successfully',
        type: 'success',
      }),
    )
  } catch (error) {}
}

function* updateCollectorRecipientsRequest({ payload }) {
  try {
    yield call(updateCollectorRecipientsApi, payload)
    yield put(updateCollectorRecipientsSuccess())
  } catch (error) {
    yield put(updateCollectorRecipientsError(error))
  }
}

export function* searchCollectors() {
  yield takeEvery(SEARCH_COLLECTORS, searchCollectorsRequest)
}

export function* autocompleteCollectors() {
  yield takeEvery(AUTOCOMPLETE_COLLECTORS, autocompleteCollectorsRequest)
}

export function* getCollector() {
  yield takeEvery(GET_COLLECTOR, getCollectorRequest)
}

export function* watchGetCollectorClients() {
  yield takeEvery(GET_COLLECTOR_CLIENTS, getCollectorClientsRequest)
}

export function* watchAddClientToCollector() {
  yield takeEvery(ADD_CLIENT_TO_COLLECTOR, addClientToCollectorRequest)
}

export function* watchRemoveClientFromCollector() {
  yield takeEvery(REMOVE_CLIENT_FROM_COLLECTOR, removeClientFromCollectorRequest)
}

export function* watchUpdateCollectorRecipients() {
  yield takeEvery(UPDATE_COLLECTOR_RECIPIENTS, updateCollectorRecipientsRequest)
}

export default function* rootSaga() {
  yield all([
    fork(searchCollectors),
    fork(autocompleteCollectors),
    fork(getCollector),
    fork(watchGetCollectorClients),
    fork(watchAddClientToCollector),
    fork(watchRemoveClientFromCollector),
    fork(watchUpdateCollectorRecipients),
  ])
}
